import React from "react";
import { ComingSoon } from "components/common";

const Contact = () => {
  return (
    <ComingSoon
      title="Contact Us"
      description="We're building a better way for you to reach out to us!"
      icon="HiOutlineMail"
    />
  );
};

export default Contact;
